<template>
  <div class="summary-bar">
    <div class="summary-grand">
      <span class="summary-grand-label">{{ $t('kachogawaPickupOverview.summary.total.title') }}</span>
      <div class="summary-grand-row">
        <span class="summary-grand-num">{{ summary.totalPrepareCount }}</span>
        <span class="summary-grand-unit">{{ $t('kachogawaPickupOverview.unit.copy') }}</span>
      </div>
    </div>
    <div
      v-for="service in summary.byService"
      :key="service.serviceId"
      class="summary-service"
    >
      <span class="summary-service-name">{{ service.serviceName }}</span>
      <span class="summary-service-num">
        {{ service.prepareCount }}<span class="summary-service-unit">{{ $t('kachogawaPickupOverview.unit.copy') }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PickupSummaryBar',
  props: {
    summary: {
      type: Object,
      required: true,
    },
  },
})
</script>

<style lang="postcss" scoped>
.summary-bar {
  @apply flex flex-wrap items-center gap-[32px];
  @apply bg-white border border-gray-40 rounded-md py-[20px] px-[24px];
}

.summary-grand {
  @apply flex flex-col gap-[4px] pr-[32px] border-r border-gray-40;
}

.summary-grand-label {
  @apply text-sub text-gray-60;
}

.summary-grand-row {
  @apply flex items-baseline gap-[6px];
}

.summary-grand-num {
  @apply text-[40px] leading-none font-bold text-primary-100;
  font-variant-numeric: tabular-nums;
}

.summary-grand-unit {
  @apply text-normal text-gray-60 font-medium;
}

.summary-service {
  @apply flex flex-col gap-[4px];
}

.summary-service-name {
  @apply text-sub text-gray-80;
}

.summary-service-num {
  @apply text-[24px] font-bold text-gray-100;
  font-variant-numeric: tabular-nums;
}

.summary-service-unit {
  @apply text-sub text-gray-60 font-medium ml-[4px];
}
</style>
